import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop, { BackdropProps } from '@mui/material/Backdrop';
import { makeStyles } from '~/tools/makeStyles';

const useStyles = makeStyles(() => ({
  backdrop: {
    zIndex: 100,
    color: '#fff',
  },
}));

function Loading(props: BackdropProps) {
  const classes = useStyles();

  return (
    <Backdrop className={classes.backdrop} data-testid="loading" {...props}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}

export default Loading;
